import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/Dashboard";
import AdminClients from "./pages/Clients";
import AdminStats from "./pages/AdminStates";
import AdminNavbar from "./components/AdminNavbar";
import AdminTransactions from "./pages/Transection";
import AdminSettings from "./pages/Setting";

// Private route
function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/admin/login" />;
}

export default function App() {
  const [token, setToken] = React.useState(localStorage.getItem("token") || "");

  // sync token reactively
  React.useEffect(() => {
    const syncToken = () => {
      setToken(localStorage.getItem("token"));
    };

    window.addEventListener("storage", syncToken);
    window.addEventListener("tokenChanged", syncToken);

    return () => {
      window.removeEventListener("storage", syncToken);
      window.removeEventListener("tokenChanged", syncToken);
    };
  }, []);

  return (
    <BrowserRouter>
      {token && <AdminNavbar />}

      <Routes>
        <Route path="/" element={<Navigate to="/admin/login" />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/clients"
          element={
            <PrivateRoute>
              <AdminClients />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/stats"
          element={
            <PrivateRoute>
              <AdminStats />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/transections"
          element={
            <PrivateRoute>
              <AdminTransactions />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/setting"
          element={
            <PrivateRoute>
              <AdminSettings />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<Navigate to="/admin/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
